import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import { Container, Card, Form, Button, ProgressBar, Badge } from 'react-bootstrap';
import './AssociarLoja.css';

function CriarUsuario() {
  const navigate = useNavigate();
  const [cpf, setCpf] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [dataNascimento, setDataNascimento] = useState("");
  const [senha, setSenha] = useState("");
  const [etapa, setEtapa] = useState(1);

  const [campoValidacao, setCampoValidacao] = useState(null);
  const [opcoesCampo, setOpcoesCampo] = useState([]);
  const [respostaCampo, setRespostaCampo] = useState("");

  const limpar = () => {
    setCpf("");
    setUsuario(null);
    setDataNascimento("");
    setSenha("");
    setEtapa(1);
    setCampoValidacao(null);
    setOpcoesCampo([]);
    setRespostaCampo("");
  };

  const somenteNumeros = (str) => str.replace(/\D/g, "");

  const buscarUsuario = async () => {
    const cpfLimpo = somenteNumeros(cpf);
    if (cpfLimpo.length !== 11) {
      Swal.fire("Erro", "CPF inválido", "error");
      return;
    }
    try {
      const { data } = await api.get(`/usuario/dados/000000?cpf=${cpfLimpo}`);
      if (data && data.length > 0) {
        const user = data[0];
        const dataAdmissao = new Date(user.dataadmissao);
        const hoje = new Date();
        const hojeSemHoras = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        const admissaoSemHoras = new Date(dataAdmissao.getFullYear(), dataAdmissao.getMonth(), dataAdmissao.getDate());
        const diffDias = (hojeSemHoras - admissaoSemHoras) / (1000 * 60 * 60 * 24);

        if (diffDias > 30) {
          Swal.fire("Atenção", "Data de admissão é maior que a data de Integração. Fazer o cadastro no aplicativo ARBOR.", "warning");
          return;
        }

        setUsuario(user);
        setEtapa(2);
      } else {
        Swal.fire("Erro", "CPF não encontrado", "error");
      }
    } catch (error) {
      Swal.fire("Erro", "Falha ao buscar usuário", "error");
    }
  };

  const validarNascimento = () => {
    if (!usuario) return;
    const nascimentoAPI = new Date(usuario.dtnascimento).toISOString().substring(0, 10);
    const nascimentoDigitado = new Date(dataNascimento).toISOString().substring(0, 10);
    if (nascimentoAPI === nascimentoDigitado) {
      gerarValidacaoExtra(usuario);
    } else {
      Swal.fire("Erro", "Data de nascimento incorreta", "error");
    }
  };

  const gerarValidacaoExtra = (user) => {
    const campos = ["rg", "bairro", "cep", "email", "ufrg"];
    const escolhido = campos[Math.floor(Math.random() * campos.length)];

    let opcoes = [];
    setRespostaCampo("");

    switch (escolhido) {
      case "bairro":
        {
          const bairrosFicticios = [
            "VILA", "SANTO AGOSTINHO", "VILA MARIA", "CENTRO",
            "TRÊS POÇOS", "PARAÍSO", "PRAÇA DA CONCORDIA",
            "ROLAMÃO", "9 DE ABRIL", "BOA VISTA", "ANO BOM", "MANEJO"
          ].filter(b => b.toUpperCase() !== user.bairro.toUpperCase());
          opcoes = shuffleArray([user.bairro, ...bairrosFicticios.slice(0, 4)]);
          setOpcoesCampo(opcoes);
        }
        break;
      case "ufrg":
        {
          const ufs = ["MG", "ES", "SP", "PR", "RS"].filter(uf => uf !== user.ufrg);
          opcoes = shuffleArray([user.ufrg, ...ufs.slice(0, 4)]);
          setOpcoesCampo(opcoes);
        }
        break;
      case "rg":
      case "cep":
      case "email":
        setOpcoesCampo([]);
        break;
      default:
        setOpcoesCampo([]);
        break;
    }

    setCampoValidacao(escolhido);
    setEtapa(3);
  };

  const shuffleArray = (array) => array.sort(() => Math.random() - 0.5);

  const validarCampoExtra = () => {
    if (!usuario || !campoValidacao) return;

    let valorCorreto = "";

    switch (campoValidacao) {
      case "rg":
        valorCorreto = somenteNumeros(usuario.rg);
        if (somenteNumeros(respostaCampo) === valorCorreto) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      case "cep":
        valorCorreto = somenteNumeros(usuario.cep);
        if (somenteNumeros(respostaCampo) === valorCorreto) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      case "email":
        valorCorreto = usuario.email.trim().toLowerCase();
        if (respostaCampo.trim().toLowerCase() === valorCorreto) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      case "bairro":
      case "ufrg":
        if (respostaCampo === usuario[campoValidacao]) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      default:
        erroValidacao();
        break;
    }
  };

  const erroValidacao = () => {
    Swal.fire("Erro", "Validação não concluída, dados não conferem", "error");
    limpar();
  };

  const salvarSenha = async () => {
    try {
      const body = { senha };
      const response = await api.post(`/usuario/${usuario.chapa}`, body);

      if (response.status === 201) {
        localStorage.setItem("chapa", usuario.chapa);
        navigate("/arbor/usuario/validar");
      } else {
        Swal.fire("Erro", response.data?.erro || "Erro desconhecido", "error");
      }

    } catch (error) {
      if (error.response && error.response.status === 406) {
        const erroMsg = error.response.data?.erro || "Erro não especificado";
        Swal.fire("Erro", erroMsg, "error");
      } else {
        Swal.fire("Erro", "Falha ao salvar senha", "error");
      }
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Menu modulo="NOVO" />

      <Container fluid className="px-3 mt-4 pt-4 mb-5" style={{ flex: 1, maxWidth: '520px' }}>
        <Card className="shadow-sm border-0 bg-white rounded-3 p-4">
          <div className="text-center mb-3">
            <h4 className="fw-bold text-dark m-0">
              <i className="fa-solid fa-user-plus text-danger me-2"></i>Criação de Usuário
            </h4>
            <span className="small text-muted">Passo {etapa} de 4</span>
          </div>

          <ProgressBar 
            now={(etapa / 4) * 100} 
            variant="danger" 
            className="mb-4" 
            style={{ height: '6px' }} 
          />

          {/* Etapa 1 - CPF */}
          {etapa === 1 && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold text-dark">Informe o seu CPF *</Form.Label>
                <InputMask
                  mask="999.999.999-99"
                  value={cpf}
                  onChange={(e) => setCpf(e.target.value)}
                >
                  {(inputProps) => <Form.Control {...inputProps} placeholder="000.000.000-00" autoFocus />}
                </InputMask>
              </Form.Group>
              <Button 
                variant="danger" 
                className="btn-arbor-primary w-100 fw-bold py-2" 
                onClick={buscarUsuario}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i>Buscar
              </Button>
            </Form>
          )}

          {/* Etapa 2 - Data nascimento */}
          {etapa === 2 && usuario && (
            <Form>
              <div className="bg-light p-3 rounded-2 border mb-3">
                <div className="small text-muted">Colaborador Localizado:</div>
                <div className="fw-bold text-dark fs-6">{usuario.nome}</div>
              </div>

              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold text-dark">Data de Nascimento *</Form.Label>
                <Form.Control
                  type="date"
                  value={dataNascimento}
                  onChange={(e) => setDataNascimento(e.target.value)}
                />
              </Form.Group>
              
              <Button 
                variant="danger" 
                className="btn-arbor-primary w-100 fw-bold py-2" 
                onClick={validarNascimento}
              >
                <i className="fa-solid fa-arrow-right me-2"></i>Confirmar
              </Button>
            </Form>
          )}

          {/* Etapa 3 - Validação extra randomizada */}
          {etapa === 3 && campoValidacao && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold text-dark">
                  Confirme o seu {campoValidacao.toUpperCase()} *
                </Form.Label>

                {(campoValidacao === "bairro" || campoValidacao === "ufrg") ? (
                  <Form.Select
                    value={respostaCampo}
                    onChange={(e) => setRespostaCampo(e.target.value)}
                  >
                    <option value="">-- Selecione uma opção --</option>
                    {opcoesCampo.map((op, idx) => (
                      <option key={idx} value={op}>{op}</option>
                    ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    type={campoValidacao === "email" ? "email" : "text"}
                    placeholder={`Digite o seu ${campoValidacao.toUpperCase()}`}
                    value={respostaCampo}
                    onChange={(e) => setRespostaCampo(e.target.value)}
                  />
                )}
              </Form.Group>

              <Button 
                variant="danger" 
                className="btn-arbor-primary w-100 fw-bold py-2" 
                onClick={validarCampoExtra} 
                disabled={!respostaCampo}
              >
                <i className="fa-solid fa-shield-halved me-2"></i>Validar Dados
              </Button>
            </Form>
          )}

          {/* Etapa 4 - Senha */}
          {etapa === 4 && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold text-dark">Crie sua Senha de Acesso *</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Mínimo de 6 caracteres"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                />
              </Form.Group>

              <Button
                variant="danger"
                className="btn-arbor-primary w-100 fw-bold py-2"
                onClick={salvarSenha}
                disabled={!senha || senha.length < 6}
              >
                <i className="fa-solid fa-user-check me-2"></i>Criar Usuário
              </Button>
            </Form>
          )}
        </Card>
      </Container>

      <Footer />
    </div>
  );
}

export default CriarUsuario;